require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuung-10-14-betreuungseinrichtungen-oberpullendorf-lutzmannsburg.json") })
        }
      }, "path---betreuung-10-14-betreuungseinrichtungen-oberpullendorf-lutzmannsburg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuung-10-14-betreuungseinrichtungen-oberpullendorf-lutzmannsburg!./.cache/json/betreuung-10-14-betreuungseinrichtungen-oberpullendorf-lutzmannsburg.json
// module id = 796
// module chunks = 231608221292675